/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateAccountResult } from '../../models/create-account-result';
import { UpdateAdvancedModeDto } from '../../models/update-advanced-mode-dto';

export interface AccountControllerUpdateAdvancedMode$Params {
  id: string;
      body: UpdateAdvancedModeDto
}

export function accountControllerUpdateAdvancedMode(http: HttpClient, rootUrl: string, params: AccountControllerUpdateAdvancedMode$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateAccountResult>> {
  const rb = new RequestBuilder(rootUrl, accountControllerUpdateAdvancedMode.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateAccountResult>;
    })
  );
}

accountControllerUpdateAdvancedMode.PATH = '/account/advancedMode/{id}';
